<template>
  <!-- 左侧二级菜单栏的组件封装 -->
  <!-- <div class="sidebar">
    <el-menu
      class="sidebar-el-menu"
      :default-active="toIndex"
      background-color="#fff"
      text-color="#000000"
      router>
      <el-menu-item v-for="(item, index) in itemList" :key="index" :index="item.path">
        需要图标的在 item 对象中加上属性 icon
        <i :class="item.icon"></i>
        <span slot="title">{{ item.title }}</span>
      </el-menu-item>
    </el-menu>
  </div> -->
  <div class="sidebar">
    <!-- 左侧二级菜单栏的组件封装 -->
    <el-menu class="el-menu-vertical-demo sidebar-el-menu"
      :default-active="toIndex()"
      text-color="#000"
      active-text-color="#126cd2" unique-opened
      
      router>
        <div v-for="item in items" :key="item.sign">
          <!-- 二级菜单 -->
          <el-menu-item :index="item.sign" :key="item.sign" v-if="item.children.length == 0">
            <span slot="title">
              <span :class="['iconfont', item.icon]"></span>
              <span>{{item.menu_name}}</span>
            </span>
          </el-menu-item>
          <!-- 三级菜单 -->
          <el-submenu :index="item.sign" v-else>
            <span slot="title">
              <span :class="['iconfont', item.icon]"></span>
              <span>{{item.menu_name}}</span>
            </span>
            <el-menu-item-group>
              <el-menu-item v-for="itemsTwo in item.children" :index="itemsTwo.sign" :key="itemsTwo.sign">
                {{itemsTwo.menu_name}}
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </div>
    </el-menu>
  </div>
</template>

<script>
export default {
  props: {
    // itemList: {
    //   type: Array,
    //   default: () => []
    // }
    items: {
      type: Array,
      default: () => []
    }
  },
  data(){
    return {

    }
  },
  computed: {
    toIndex(){  // 根据路径绑定到对应的二级菜单，防止页面刷新重新跳回第一个
    console.log(this.$route.path.split('/')[2])
    //   return this.$route.path.split('/')[2];
    // let i=this.$route.path.split('/')[2];
      return function(){			//使用函数返回
				return this.$route.path.split('/')[2]
			}
    }
  },
  methods:{
      
  },
}
</script>

<style lang="scss" scoped>
/* 左侧菜单栏定位和位置大小设定 */
.sidebar {
  display: block;
  position: absolute;
  left: 0;
  // top: 70px;
  top: 50px;
  bottom: 0;
  overflow-y: scroll;
}
.sidebar::-webkit-scrollbar {
  width: 0;
}
.sidebar-el-menu {
  width: 170px;
}
.sidebar > ul {
  height: 100%;
  border-right:1px solid #d9d9d9;
}
  // .el-submenu__title i{
  //   color:#000;
  // }
// .el-menu{
//   background:#0969BD!important;
// }
.el-menu :hover{
  background:#fff!important;
}
/* 左侧二级菜单项的样式 */
.el-menu-item{
  font-size: 13px!important;
}
.el-menu-item-group .el-menu-item{
  font-size: 12px!important;
}
// .el-submenu .el-menu-item {
//   background:#0970BD!important;
// }
// .el-menu-item-group .el-menu-item {
//   background:#0970BD!important;
// }
/* 左侧二级菜单选中时的样式 */
.el-menu-item-group .is-active {
  background: #e7eefe !important;
}
.el-menu-item, .el-submenu__title {
  height: 40px !important;
  line-height: 40px !important;
}
// .el-submenu{
//   background:#0969BD!important;
// }
// .el-submenu .el-submenu__title{
//   background-color: #0969BD!important;
// }
</style>
<style>

</style>


// WEBPACK FOOTER //
// src/components/sidemenu/SideMenu.vue